import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const fiatWalletRoutes: RouteRecordRaw[] = [
  {
    path: routes.WALLET_TRANSACTIONS,
    name: 'WALLET_TRANSACTIONS',
    component: () => import('./WalletTransactionsPage.vue'),
    meta: { requiresAuth: true, title: 'Transaction History' },
  },
  {
    path: routes.WALLET_TRANSACTION_DETAIL,
    name: 'WALLET_TRANSACTION_DETAIL',
    component: () => import('./TransactionDetailPage.vue'),
    meta: { requiresAuth: true, title: 'Transaction Details' },
  },
  {
    path: routes.WALLET_DEPOSIT_SUCCESS,
    name: 'WALLET_DEPOSIT_SUCCESS',
    component: () => import('./WalletDepositSuccessPage.vue'),
    meta: { requiresAuth: true, title: 'Deposit Submitted' },
  },
]
